import React from 'react';
import PropTypes from 'prop-types';
import PeriodTabsListing from '../PeriodTabs/PeriodTabsListing';
import courseSemesterSpec from './courseSemesters';
import FlexCourseCard from './FlexCourseCard';

/**
 * Courses with a bar of semesters, newest first.
 *
 * `/teaching` used to carry one hand-written listing block per semester, with
 * the semester spelled into the headline and into the query - four of them,
 * and a fifth to add every autumn. One block with this variation covers all
 * 36 semesters the site holds, and the four most recent are what it shows
 * until a visitor picks another.
 */
const CourseSemesterTabsView = (props) => (
  <PeriodTabsListing
    {...props}
    spec={courseSemesterSpec}
    card={FlexCourseCard}
    cardProps={{
      compact: props.compact,
      hideLink: props.hide_link,
      gridLayout: props.grid_layout,
    }}
  />
);

CourseSemesterTabsView.propTypes = {
  compact: PropTypes.bool,
  hide_link: PropTypes.bool,
  grid_layout: PropTypes.bool,
};

export default CourseSemesterTabsView;
